import { parseZone } from "moment-timezone";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

const Minute = 60 * 1000;
const Hour = 60 * Minute;
export const parkingTypes = ["PARKING_TWO", "PARKING_FOUR"];

export function getAdditionalBookings(booking: NsEmpWebExpData.IBookingDetailDTOS, types: string[]): NsEmpWebExpData.IBookingDetailDTOS[] | null {
  const bookings = booking?.additionalBookings?.filter(b => types.includes(b.premiseType) && b.requestStatus !== "CANCELLED");
  return bookings?.length > 0 ? bookings : null;
}
export function queryGenerator(buid: string, empGuid: string, start: number, end: number, types?: string[]): string {
  const query = '{getEmployee(where : {buid:"' + buid + '", empGuid:["' + empGuid + '"]';
  return query + ", startDateBooking: " + start + ", endDateBooking: " + end + (types?.length > 0 ? ", bookingTypes: " + types.join(",") : "") + "})";
}
export function getAdditionalUsersBookings(booking: NsEmpWebExpData.IBookingRequest, types: string[]): NsEmpWebExpData.IUsersBookingEntity[] | null {
  const bookings = booking?.usersBooking.filter(b => types.includes(b.type));
  return bookings?.length > 0 ? bookings : null;
}

export function getUsersBooking(booking: NsEmpWebExpData.IBookingRequest, types: string[]): NsEmpWebExpData.IUsersBookingEntity[] | null {
  const userBooking = booking?.usersBooking?.filter(booking => types.includes(booking.type));
  return userBooking?.length > 0 ? userBooking : null;
}

export function getUserRequestDTOS(booking: NsEmpWebExpData.IBookingDetailDTOS): boolean {
  const cabToShow = booking.userRequestDTOS.find(item => item.status !== "SCHEDULE_CANCELLED");
  if (cabToShow) return true;
  return false;
}

export const validateHeroBooking = (booking: NsEmpWebExpData.IBookingDetailDTOS, timezone): boolean => {
  if (!booking) return false;
  const now = parseZone().tz(timezone);
  let today = now.clone().startOf("day");
  let tonight = parseZone().tz(timezone).endOf("day");
  return (
    parseZone(booking.startTime)
      .tz(booking.timezone || timezone)
      .isSameOrBefore(tonight) &&
    parseZone(booking.startTime)
      .tz(booking.timezone || timezone)
      .isSameOrAfter(today)
  );
};

export const processShifts = ({ login, logout, nextDay }, start, timezone, timeFormat) => {
  return [login, logout, nextDay].map((list, idx) =>
    list.map(item => {
      const time = Number(start) + item?.hours * Hour + item?.minutes * Minute;
      return {
        ...item,
        label: parseZone(time).tz(timezone).format(timeFormat),
        tags: item?.tags ? JSON.parse(item?.tags) : {},
        isAdhoc: item?.type === "ADHOC" ? true : false,
        timeInMinutes: item?.timeInMinutes + (idx === 2 ? 24 * 60 : 0)
      };
    })
  );
};

export const partialCancellation = (booking: NsEmpWebExpData.IBookingDetailDTOS) => {
  const transport = booking?.userRequestDTOS
    ?.map(item => {
      return item.status === "SCHEDULED";
    })
    .find(val => val === true);
  return booking.requestStatus === "CANCELLED" && transport ? true : false;
};

export const tagsBasedOnStatus = (booking: NsEmpWebExpData.IBookingDetailDTOS) => {
  let statusToDisplay;
  if (booking.requestStatus === "PENDING") statusToDisplay = "IN REVIEW";
  else if (booking.requestStatus === "CONFIRMED") statusToDisplay = "APPROVED";
  else if (booking.requestStatus === "REJECTED") statusToDisplay = "REJECTED";
  return statusToDisplay;
};

export const appprovalDataListGenerator = (booking: NsEmpWebExpData.IBookingDetailDTOS): NsEmpWebExpData.IApprovalDataList => {
  const approvalTime =
    parseZone(booking.autoApprovalTime).tz(booking.timezone).format("DD/MMM/YYYY") +
    " " +
    parseZone(booking.autoApprovalTime).tz(booking.timezone).format("hh:mm a");
  let statusToDisplay = tagsBasedOnStatus(booking);
  let message;
  if (booking.approvalType === "AUTO_REJECT") message = "Auto cancels on " + `${approvalTime}`;
  else if (booking.approvalType === "AUTO_APPROVED") message = "Will be auto approved on " + `${approvalTime}`;

  return {
    requestStatus: booking.requestStatus,
    statusToDisplay: statusToDisplay,
    approvalType: booking.approvalType,
    autoApprovalTime: booking.autoApprovalTime,
    message: message,
    pendingStateMessage: booking.requestStatus === "PENDING" ? "Sent to manager for approval" : undefined
  };
};
export const getTypeOfTransport = (booking: NsEmpWebExpData.IBookingDetailDTOS, transportDirection: string) => {
  const transport = booking.userRequestDTOS.find(item => item.direction === transportDirection && item.status === "SCHEDULED");
  if (transport) {
    return booking;
  }
  return null;
};

export const minLength = (length: number) => (iterable: Array<unknown> | string) => ({ minLength: iterable.length > length });
export const timeString = (shift, timezone, startDate) => {
  if (!shift) {
    return parseZone().tz(timezone).startOf("day").valueOf().toString();
  }
  const dateStart = parseZone(startDate).tz(timezone).startOf("day");
  return dateStart.add(shift, "minutes").valueOf().toString();
};

export const labelForShifts = (time: number, timezone: string, timeFormat: string) => {
  return { label: parseZone(time).tz(timezone).format(timeFormat), shiftNotFound: true };
};
